import { render, staticRenderFns } from "./SupplyView.vue?vue&type=template&id=323675a8&scoped=true"
import script from "./SupplyView.vue?vue&type=script&lang=js"
export * from "./SupplyView.vue?vue&type=script&lang=js"
import style0 from "./SupplyView.vue?vue&type=style&index=0&id=323675a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323675a8",
  null
  
)

export default component.exports